(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-listicle-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.advertorialCountdownInitialized) return;
    window.advertorialCountdownInitialized = true;

    const pad = (value) => String(value).padStart(2, '0');

    const parseDuration = (value) => {
      const parts = String(value || '').match(/\d+/g);
      if (!parts || !parts.length) return 0;

      const numbers = parts.map((part) => Number(part));
      if (numbers.length >= 3) return numbers[0] * 3600 + numbers[1] * 60 + numbers[2];
      if (numbers.length === 2) return numbers[0] * 60 + numbers[1];
      return numbers[0];
    };

    const formatDuration = (totalSeconds) => {
      const seconds = Math.max(0, Math.floor(totalSeconds));
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-advertorial-countdown]').forEach((timer) => {
        if (!timer.dataset.countdownEndsAt) {
          const duration = parseDuration(timer.dataset.countdownInitial);
          timer.dataset.countdownEndsAt = String(Date.now() + duration * 1000);
        }

        const display = timer.querySelector('[data-countdown-display]');
        if (!display) return;

        const remaining = (Number(timer.dataset.countdownEndsAt) - Date.now()) / 1000;
        display.textContent = formatDuration(remaining);
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        if (this.elements.button && this.elements.panel) {
          this.elements.button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.openSelector(event);
          });
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.addEventListener('click', (event) => {
            event.stopPropagation();
          });
          this.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', (event) => {
              event.stopPropagation();
              this.onItemClick(event);
            });
          });
          
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target) && !this.elements.panel.hasAttribute('hidden')) {
              this.hidePanel();
            }
          });
        }
      }

      hidePanel() {
        if (this.elements.button && this.elements.panel) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        if (this.elements.button) this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (!form) return;
        
        const input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        if (!input) return;
        
        const selectedValue = event.currentTarget.dataset.value;
        if (!selectedValue) return;
        
        if (input.value === selectedValue) {
          this.hidePanel();
          return;
        }
        
        input.value = selectedValue;
        
        let hiddenMethod = form.querySelector('input[name="_method"]');
        if (!hiddenMethod) {
          hiddenMethod = document.createElement('input');
          hiddenMethod.type = 'hidden';
          hiddenMethod.name = '_method';
          hiddenMethod.value = 'put';
          form.appendChild(hiddenMethod);
        }
        
        this.hidePanel();
        form.submit();
      }

      openSelector(event) {
        if (event) {
          event.stopPropagation();
        }
        if (this.elements.button && this.elements.panel) {
          const isHidden = this.elements.panel.hasAttribute('hidden');
          this.elements.button.focus();
          if (isHidden) {
            this.elements.panel.removeAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', 'true');
          } else {
            this.hidePanel();
          }
        }
      }

      closeSelector(event) {
        if (!this.elements.panel || !this.elements.button) return;
        
        const isClickInside = this.contains(event.relatedTarget);
        const isButton = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        
        if (!isClickInside || isButton) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const closeTopBtn = document.querySelector('.menu-drawer__close-top-btn');
    const menuDrawer = document.querySelector('#menu-drawer');
    const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (closeTopBtn && menuDrawerDetails) {
      closeTopBtn.addEventListener('click', function() {
        if (menuDrawerDetails instanceof HTMLDetailsElement) {
          menuDrawerDetails.removeAttribute('open');
           document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }
    
    // Also handle when menu drawer closes via other methods (e.g., clicking outside)
    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener('toggle', function() {
        if (!menuDrawerDetails.hasAttribute('open')) {
          // Remove overflow-hidden classes from body when menu closes
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    const localizationSelects = document.querySelectorAll('.menu-drawer__localization-select');
    localizationSelects.forEach(select => {
      select.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('change', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    });

    const resetButton = document.querySelector('.menu-drawer__search .reset__button');
    if (resetButton) {
      resetButton.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      resetButton.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    }

    const searchForm = document.querySelector('.menu-drawer__search form');
    if (searchForm) {
      searchForm.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchForm.addEventListener('submit', function(event) {
        event.stopPropagation();
      });
    }

    const searchInput = document.querySelector('.menu-drawer__search .search__input');
    const resetButtonMenuDrawer = document.querySelector('.menu-drawer__search .reset__button');
    
    if (searchInput && resetButtonMenuDrawer) {
      searchInput.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchInput.addEventListener('focus', function(event) {
        event.stopPropagation();
      });
      
      function toggleResetButton() {
        if (searchInput.value.length > 0) {
          resetButtonMenuDrawer.classList.remove('hidden');
        } else {
          resetButtonMenuDrawer.classList.add('hidden');
        }
      }
      
      toggleResetButton();
      
      searchInput.addEventListener('input', function() {
        toggleResetButton();
      });
      
      const searchFormMenuDrawer = searchInput.closest('form');
      if (searchFormMenuDrawer) {
        searchFormMenuDrawer.addEventListener('reset', function() {
          setTimeout(toggleResetButton, 0);
        });
      }
    }

    // Close country selector dropdowns when clicking outside or on search (capture so we run before search stopPropagation)
    document.addEventListener('click', function(event) {
      const headerLocalization = document.querySelector('.header-localization');
      const menuDrawerLocalizations = document.querySelectorAll('.menu-drawer__localization');
      const clickedOnSearch = event.target.closest('.header__search, .menu-drawer__search');
      
      // Close header localization dropdown if open and click is outside (or on search)
      if (headerLocalization && headerLocalization.hasAttribute('open')) {
        if (!headerLocalization.contains(event.target) || clickedOnSearch) {
          headerLocalization.removeAttribute('open');
        }
      }
      
      // Close all menu drawer localization dropdowns (language + country) if open and click is outside (or on search)
      menuDrawerLocalizations.forEach(function(details) {
        if (details.hasAttribute('open') && (!details.contains(event.target) || clickedOnSearch)) {
          details.removeAttribute('open');
        }
      });
    }, true);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nine-reasons-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.nineReasonsCountdownInitialized) return;
    window.nineReasonsCountdownInitialized = true;

    const getRemainingParts = () => {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(24, 0, 0, 0);

      const diff = Math.max(0, endOfDay.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      return {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds),
      };
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-nine-reasons-countdown]').forEach((timer) => {
        const parts = getRemainingParts();
        const hours = timer.querySelector('[data-countdown-hours]');
        const minutes = timer.querySelector('[data-countdown-minutes]');
        const seconds = timer.querySelector('[data-countdown-seconds]');

        if (hours && minutes && seconds) {
          hours.textContent = parts.hours;
          minutes.textContent = parts.minutes;
          seconds.textContent = parts.seconds;
          return;
        }

        const prefix = timer.dataset.countdownPrefix;
        const formatted = `${parts.hours} : ${parts.minutes} : ${parts.seconds}`;
        timer.textContent = prefix ? `${prefix} ${formatted}` : formatted;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nine-reasons-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.nineReasonsCountdownInitialized) return;
    window.nineReasonsCountdownInitialized = true;

    const getRemainingParts = () => {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(24, 0, 0, 0);

      const diff = Math.max(0, endOfDay.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      return {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds),
      };
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-nine-reasons-countdown]').forEach((timer) => {
        const parts = getRemainingParts();
        const hours = timer.querySelector('[data-countdown-hours]');
        const minutes = timer.querySelector('[data-countdown-minutes]');
        const seconds = timer.querySelector('[data-countdown-seconds]');

        if (hours && minutes && seconds) {
          hours.textContent = parts.hours;
          minutes.textContent = parts.minutes;
          seconds.textContent = parts.seconds;
          return;
        }

        const prefix = timer.dataset.countdownPrefix;
        const formatted = `${parts.hours} : ${parts.minutes} : ${parts.seconds}`;
        timer.textContent = prefix ? `${prefix} ${formatted}` : formatted;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeKey = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

    const parseJson = (node, fallback) => {
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent || '');
      } catch (error) {
        return fallback;
      }
    };

    const parseScoreRules = (rules) => {
      const scores = [];
      String(rules || '')
        .split(/[\n,;]+/)
        .map((rule) => rule.trim())
        .filter(Boolean)
        .forEach((rule) => {
          const parts = rule.split(/[:=]/);
          const key = normalizeKey(parts[0]);
          const points = Number.parseFloat(parts[1]);
          if (key) {
            scores.push({ key, points: Number.isFinite(points) ? points : 1 });
          }
        });
      return scores;
    };

    class SkincareQuiz {
      constructor(root) {
        this.root = root;
        this.source = root.querySelector('[data-sq-source]');
        this.config = parseJson(root.querySelector('[data-sq-config]'), { labels: {} });
        this.labels = this.config.labels || {};
        this.quiz = root.querySelector('[data-sq-quiz]');
        this.form = root.querySelector('[data-sq-form]');
        this.step = root.querySelector('[data-sq-step]');
        this.progress = root.querySelector('[data-sq-progress]');
        this.progressbar = root.querySelector('[data-sq-progressbar]');
        this.title = root.querySelector('[data-sq-title]');
        this.helper = root.querySelector('[data-sq-helper]');
        this.answers = root.querySelector('[data-sq-answers]');
        this.error = root.querySelector('[data-sq-error]');
        this.back = root.querySelector('[data-sq-back]');
        this.next = root.querySelector('[data-sq-next]');
        this.resultWrap = root.querySelector('[data-sq-result-wrap]');
        this.resultTarget = root.querySelector('[data-sq-result]');
        this.restart = root.querySelector('[data-sq-restart]');
        this.empty = root.querySelector('[data-sq-empty]');
        this.welcome = root.querySelector('[data-sq-welcome]');
        this.flow = root.querySelector('[data-sq-flow]');
        this.startButton = root.querySelector('[data-sq-start]');
        this.questions = this.readQuestions();
        this.results = this.readResults();
        this.resultOrder = Array.from(this.results.keys());
        this.index = 0;
        this.selections = new Map();
        this.completed = false;
        this.started = false;
        this.abandonTracked = false;
        this.bind();
        this.start();
      }

      readQuestions() {
        return Array.from(this.source.querySelectorAll('[data-quiz-question-block]'))
          .map((block) => {
            const question = parseJson(block.querySelector('[data-quiz-question-meta]'), null);
            if (!question) return null;
            question.answers = Array.from(block.querySelectorAll('[data-quiz-answer]'))
              .map((node) => parseJson(node, null))
              .filter((answer) => answer && answer.label);
            return question;
          })
          .filter((question) => question && question.title && question.answers.length);
      }

      readResults() {
        const results = new Map();
        Array.from(this.source.querySelectorAll('template[data-quiz-result]')).forEach((template) => {
          const key = normalizeKey(template.dataset.resultKey);
          if (key && !results.has(key)) {
            results.set(key, template);
          }
        });
        return results;
      }

      bind() {
        this.form.addEventListener('change', () => this.storeCurrentSelection());
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.goNext();
        });
        this.back.addEventListener('click', () => this.goBack());
        this.restart.addEventListener('click', () => this.reset());
        if (this.startButton) {
          this.startButton.addEventListener('click', () => this.beginQuiz());
        }
        window.addEventListener('pagehide', () => this.trackAbandonment());
        this.resultWrap.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sq-add-products]');
          if (button && this.resultWrap.contains(button)) {
            this.addResultProducts(button);
          }
        });
      }

      start() {
        if (!this.questions.length || !this.results.size) {
          if (this.welcome) this.welcome.hidden = true;
          if (this.flow) this.flow.hidden = false;
          this.quiz.hidden = true;
          this.resultWrap.hidden = true;
          this.empty.hidden = false;
          return;
        }
        this.empty.hidden = true;
        this.resultWrap.hidden = true;
        if (this.welcome) {
          this.welcome.hidden = false;
          if (this.flow) this.flow.hidden = true;
          this.trackEvent('elanora_skin_quiz_welcome_viewed', {
            question_total: this.questions.length
          });
        } else {
          this.beginQuiz();
        }
      }

      beginQuiz() {
        if (this.welcome) this.welcome.hidden = true;
        if (this.flow) this.flow.hidden = false;
        this.empty.hidden = true;
        this.resultWrap.hidden = true;
        this.quiz.hidden = false;
        if (!this.started) {
          this.started = true;
          this.trackEvent('elanora_skin_quiz_started', {
            question_total: this.questions.length
          });
        }
        this.renderQuestion();
        if (this.welcome) {
          this.quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      currentQuestion() {
        return this.questions[this.index];
      }

      stepLabel() {
        const current = this.index + 1;
        const total = this.questions.length;
        return String(this.labels.step || '[current] / [total]')
          .replace('[current]', current)
          .replace('[total]', total);
      }

      renderQuestion() {
        const question = this.currentQuestion();
        const current = this.index + 1;
        const total = this.questions.length;
        const selected = this.selections.get(question.key) || new Set();
        this.step.textContent = this.stepLabel();
        this.progress.style.width = `${(current / total) * 100}%`;
        this.progressbar.setAttribute('aria-valuemax', String(total));
        this.progressbar.setAttribute('aria-valuenow', String(current));
        this.title.textContent = question.title;
        this.helper.textContent = question.helper || '';
        this.helper.hidden = !question.helper;
        this.error.hidden = true;
        this.error.textContent = '';
        this.back.hidden = this.index === 0;
        this.next.textContent = this.index === total - 1 ? this.labels.finish : this.labels.next;
        this.renderAnswers(question, selected);
        this.trackEvent('elanora_skin_quiz_question_viewed', {
          question_index: current,
          question_total: total,
          question_key: question.key,
          question_title: question.title
        });
      }

      renderAnswers(question, selected) {
        const fragment = document.createDocumentFragment();
        question.answers.forEach((answer, answerIndex) => {
          const label = document.createElement('label');
          label.className = 'skincare-quiz__answer';

          const input = document.createElement('input');
          input.type = question.multiple ? 'checkbox' : 'radio';
          input.name = `skincare-quiz-${question.key}`;
          input.value = answer.id;
          input.checked = selected.has(answer.id);

          const icon = document.createElement('span');
          icon.className = 'skincare-quiz__answer-icon';
          icon.textContent = answer.icon || String(answerIndex + 1);

          const text = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'skincare-quiz__answer-title';
          title.textContent = answer.label;
          text.append(title);

          if (answer.description) {
            const description = document.createElement('span');
            description.className = 'skincare-quiz__answer-description';
            description.textContent = answer.description;
            text.append(description);
          }

          label.append(input, icon, text);
          fragment.append(label);
        });
        this.answers.replaceChildren(fragment);
      }

      storeCurrentSelection() {
        const question = this.currentQuestion();
        const selected = new Set(
          Array.from(this.answers.querySelectorAll('input:checked')).map((input) => input.value)
        );
        this.selections.set(question.key, selected);
        this.error.hidden = true;
      }

      hasCurrentSelection() {
        const question = this.currentQuestion();
        const selected = this.selections.get(question.key);
        return selected && selected.size > 0;
      }

      goNext() {
        this.storeCurrentSelection();
        if (!this.hasCurrentSelection()) {
          this.error.textContent = this.labels.error || 'Choose an answer to continue.';
          this.error.hidden = false;
          return;
        }
        this.trackEvent('elanora_skin_quiz_question_answered', this.currentSelectionPayload());
        if (this.index >= this.questions.length - 1) {
          this.showResult();
          return;
        }
        this.index += 1;
        this.renderQuestion();
      }

      goBack() {
        if (this.index === 0) return;
        this.storeCurrentSelection();
        this.index -= 1;
        this.renderQuestion();
      }

      calculateResultKey() {
        const scores = new Map();
        this.questions.forEach((question) => {
          const selected = this.selections.get(question.key);
          if (!selected) return;
          selected.forEach((answerId) => {
            const answer = question.answers.find((candidate) => candidate.id === answerId);
            if (!answer) return;
            parseScoreRules(answer.scores).forEach((score) => {
              scores.set(score.key, (scores.get(score.key) || 0) + score.points);
            });
          });
        });

        const fallbackKey = normalizeKey(this.config.fallbackResultKey);
        if (!scores.size && this.results.has(fallbackKey)) return fallbackKey;

        let bestKey = this.results.has(fallbackKey) ? fallbackKey : this.resultOrder[0];
        let bestScore = Number.NEGATIVE_INFINITY;
        this.resultOrder.forEach((key) => {
          const score = scores.get(key) || 0;
          if (score > bestScore) {
            bestScore = score;
            bestKey = key;
          }
        });
        return this.results.has(bestKey) ? bestKey : this.resultOrder[0];
      }

      showResult() {
        const key = this.calculateResultKey();
        const template = this.results.get(key);
        if (!template) return;
        this.resultTarget.replaceChildren(template.content.cloneNode(true));
        this.upgradeResultCard();
        this.completed = true;
        this.quiz.hidden = true;
        this.resultWrap.hidden = false;
        this.resultWrap.focus({ preventScroll: true });
        this.resultWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.trackEvent('elanora_skin_quiz_completed', {
          result_key: key,
          selections: this.allSelectionsPayload(),
          products: this.resultProductsPayload()
        });
        this.trackEvent('elanora_skin_quiz_result_viewed', {
          result_key: key,
          products: this.resultProductsPayload()
        });
      }

      upgradeResultCard() {
        const card = this.resultTarget.querySelector('.skincare-quiz__result-card');
        if (!card) return;

        card.querySelectorAll('.skincare-quiz-product__cta').forEach((link) => link.remove());
        card.querySelectorAll('.skincare-quiz-product__footer a').forEach((link) => {
          if (link.textContent.trim().toLowerCase() === 'bekijk') {
            link.remove();
          }
        });

        card.querySelectorAll('.skincare-quiz-product').forEach((productCard) => {
          if (productCard.hasAttribute('data-sq-product')) return;
          const productLink = productCard.querySelector('.skincare-quiz-product__title a, .skincare-quiz-product__media');
          const href = productLink ? productLink.getAttribute('href') : '';
          const handleMatch = href ? href.match(/\/products\/([^/?#]+)/) : null;
          productCard.setAttribute('data-sq-product', '');
          if (handleMatch && handleMatch[1]) {
            productCard.setAttribute('data-sq-product-handle', handleMatch[1]);
          }
        });

        this.groupRoutine(card);

        const products = card.querySelector('.skincare-quiz__products');
        if (!products) return;

        if (card.querySelector('[data-sq-add-products]')) {
          this.updateSavingsMessage(card);
          return;
        }

        const actions = document.createElement('div');
        actions.className = 'skincare-quiz__result-actions';
        actions.innerHTML = `
          <div class="skincare-quiz__routine-savings" data-sq-routine-savings hidden></div>
          <button
            class="skincare-quiz__bulk-add"
            type="button"
            data-sq-add-products
            data-adding-label="Producten toevoegen..."
            data-success-label="Producten toegevoegd aan je winkelwagen."
            data-error-label="Er ging iets mis. Probeer opnieuw."
            data-empty-label="Geen beschikbare producten om toe te voegen."
          >
            <svg aria-hidden="true" focusable="false" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path d="M0.789062 3.01221L3.89567 3.21592L5.73271 12.6303H16.755L19.3341 4.93656L6.88223 4.88563" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.74051 18.3741C8.54212 18.3741 9.19196 17.7243 9.19196 16.9226C9.19196 16.121 8.54212 15.4712 7.74051 15.4712C6.9389 15.4712 6.28906 16.121 6.28906 16.9226C6.28906 17.7243 6.9389 18.3741 7.74051 18.3741Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.803 18.3741C15.6046 18.3741 16.2545 17.7243 16.2545 16.9226C16.2545 16.121 15.6046 15.4712 14.803 15.4712C14.0014 15.4712 13.3516 16.121 13.3516 16.9226C13.3516 17.7243 14.0014 18.3741 14.803 18.3741Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.7749 15.4714H5.52344L6.51289 12.6304" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span
              class="skincare-quiz__bulk-add-copy"
            >
              <span
              data-sq-add-products-label
              data-label-desktop="Voeg routine toe aan winkelwagen"
              data-label-mobile="Voeg routine toe"
              >
                <span class="skincare-quiz__bulk-add-label-desktop">Voeg routine toe aan winkelwagen</span>
                <span class="skincare-quiz__bulk-add-label-mobile">Voeg routine toe</span>
              </span>
              <span class="skincare-quiz__bulk-add-guarantee">30 Day Money Back Guarantee</span>
            </span>
            <span class="skincare-quiz__bulk-add-spinner" data-sq-add-products-spinner hidden></span>
          </button>
          <p class="skincare-quiz__bulk-add-message" data-sq-add-products-message hidden></p>
        `;
        products.insertAdjacentElement('afterend', actions);
        this.updateSavingsMessage(card);
      }

      groupRoutine(card) {
        const products = card.querySelector('.skincare-quiz__products');
        if (!products || products.dataset.sqGrouped === 'true') return;

        const cards = Array.from(products.querySelectorAll('.skincare-quiz-product'));
        if (!cards.length) return;

        const routineLabels = this.labels.routine || {};
        const order = [
          { key: 'morning', label: routineLabels.morning || 'Morning routine' },
          { key: 'evening', label: routineLabels.evening || 'Evening routine' },
          { key: 'both', label: routineLabels.both || 'Morning & evening' }
        ];
        const buckets = { morning: [], evening: [], both: [] };
        cards.forEach((node) => {
          const time = String(node.dataset.routineTime || 'both').toLowerCase();
          (buckets[time] || buckets.both).push(node);
        });

        const activeGroups = order.filter((group) => buckets[group.key].length);
        if (!activeGroups.length) return;
        const showHeaders = !(activeGroups.length === 1 && activeGroups[0].key === 'both');

        const fragment = document.createDocumentFragment();
        activeGroups.forEach((group) => {
          const items = buckets[group.key];
          if (showHeaders) {
            const wrapper = document.createElement('div');
            wrapper.className = 'skincare-quiz__routine-group';
            wrapper.dataset.routine = group.key;
            wrapper.append(this.buildRoutineHeader(group.key, group.label));
            const list = document.createElement('div');
            list.className = 'skincare-quiz__routine-list';
            items.forEach((node, itemIndex) => {
              this.addStepNumber(node, itemIndex + 1);
              list.append(node);
            });
            wrapper.append(list);
            fragment.append(wrapper);
          } else {
            items.forEach((node, itemIndex) => {
              this.addStepNumber(node, itemIndex + 1);
              fragment.append(node);
            });
          }
        });

        products.replaceChildren(fragment);
        products.dataset.sqGrouped = 'true';
      }

      buildRoutineHeader(key, label) {
        const glyphs = {
          morning:
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="4.5" stroke="currentColor" stroke-width="1.4"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.2 5.2l2.1 2.1M16.7 16.7l2.1 2.1M18.8 5.2l-2.1 2.1M7.3 16.7l-2.1 2.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
          evening:
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
          both:
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="9" cy="12" r="3.4" stroke="currentColor" stroke-width="1.4"/><path d="M9 4.5v2M9 17.5v2M2.5 12h2M13.5 12h2M4.6 7.6l1.4 1.4M12 16l1.4 1.4M13.4 7.6 12 9M6 16l-1.4 1.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M21 14.6a4.8 4.8 0 0 1-6.3-6.1 5.7 5.7 0 1 0 6.3 6.1Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>'
        };
        const header = document.createElement('div');
        header.className = 'skincare-quiz__routine-group-header';
        const glyph = document.createElement('span');
        glyph.className = 'skincare-quiz__routine-glyph';
        glyph.setAttribute('aria-hidden', 'true');
        glyph.innerHTML = glyphs[key] || '';
        const name = document.createElement('span');
        name.className = 'skincare-quiz__routine-name';
        name.textContent = label;
        const rule = document.createElement('span');
        rule.className = 'skincare-quiz__routine-rule';
        rule.setAttribute('aria-hidden', 'true');
        header.append(glyph, name, rule);
        return header;
      }

      addStepNumber(node, position) {
        if (node.querySelector('.skincare-quiz-product__step')) return;
        const step = document.createElement('span');
        step.className = 'skincare-quiz-product__step';
        step.setAttribute('aria-hidden', 'true');
        step.textContent = String(position);
        const media = node.querySelector('.skincare-quiz-product__media');
        if (media) {
          media.append(step);
        } else {
          node.insertBefore(step, node.firstChild);
        }
      }

      formatMoney(cents) {
        const amount = Number(cents) || 0;
        const currency =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
          document.documentElement.dataset.currency ||
          'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
            style: 'currency',
            currency
          }).format(amount / 100);
        } catch (error) {
          return `€${(amount / 100).toFixed(2)}`;
        }
      }

      productPayload(productCard) {
        return {
          handle: productCard.dataset.sqProductHandle || '',
          title: productCard.dataset.sqProductTitle || '',
          variant_id: productCard.dataset.sqProductVariantId || '',
          price: Number(productCard.dataset.sqProductPrice) || 0,
          compare_at_price: Number(productCard.dataset.sqProductComparePrice) || 0,
          available: productCard.dataset.sqProductAvailable !== 'false'
        };
      }

      resultProductsPayload(card = this.resultTarget) {
        return Array.from(card.querySelectorAll('[data-sq-product]')).map((product) =>
          this.productPayload(product)
        );
      }

      updateSavingsMessage(card) {
        const products = this.resultProductsPayload(card);
        const savings = card.querySelector('[data-sq-routine-savings]');
        if (!savings || !products.length) return;

        const routineTotal = products.reduce((total, product) => total + product.price, 0);
        const normalTotal = products.reduce((total, product) => {
          const compareAt = product.compare_at_price > product.price ? product.compare_at_price : product.price;
          return total + compareAt;
        }, 0);
        const savedTotal = normalTotal - routineTotal;

        if (!routineTotal) {
          savings.hidden = true;
          return;
        }

        if (savedTotal > 0) {
          const savedPercent = Math.max(1, Math.round((savedTotal / normalTotal) * 100));
          savings.innerHTML = `
            <span>Save ${savedPercent}% on Your Complete Routine</span>
            <small>Normally ${this.formatMoney(normalTotal)} • Your Routine ${this.formatMoney(routineTotal)}</small>
          `;
        } else {
          savings.innerHTML = `<span>Your Complete Routine ${this.formatMoney(routineTotal)}</span>`;
        }

        savings.hidden = false;
      }

      setBulkAddLoading(button, isLoading) {
        const label = button.querySelector('[data-sq-add-products-label]');
        const spinner = button.querySelector('[data-sq-add-products-spinner]');
        if (!button.dataset.originalLabel && label) {
          button.dataset.originalLabel = label.dataset.labelDesktop || label.textContent.trim();
        }
        if (!button.dataset.originalLabelHtml && label) {
          button.dataset.originalLabelHtml = label.innerHTML;
        }
        button.disabled = isLoading;
        button.classList.toggle('is-loading', isLoading);
        button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (spinner) spinner.hidden = !isLoading;
        if (label) {
          if (isLoading) {
            label.textContent = button.dataset.addingLabel || button.dataset.originalLabel;
          } else {
            label.innerHTML = button.dataset.originalLabelHtml || button.dataset.originalLabel;
          }
        }
      }

      setBulkAddMessage(button, text, isError) {
        const card = button.closest('.skincare-quiz__result-card');
        const message = card ? card.querySelector('[data-sq-add-products-message]') : null;
        if (!message) return;
        message.textContent = text || '';
        message.hidden = !text;
        message.classList.toggle('is-error', Boolean(isError));
      }

      currentSelectionPayload() {
        const question = this.currentQuestion();
        const selected = this.selections.get(question.key) || new Set();
        const selectedAnswers = question.answers
          .filter((answer) => selected.has(answer.id))
          .map((answer) => ({
            id: answer.id,
            label: answer.label
          }));

        return {
          question_index: this.index + 1,
          question_total: this.questions.length,
          question_key: question.key,
          question_title: question.title,
          selected_answer_ids: selectedAnswers.map((answer) => answer.id),
          selected_answer_labels: selectedAnswers.map((answer) => answer.label)
        };
      }

      allSelectionsPayload() {
        return this.questions.map((question, questionIndex) => {
          const selected = this.selections.get(question.key) || new Set();
          const selectedAnswers = question.answers
            .filter((answer) => selected.has(answer.id))
            .map((answer) => ({
              id: answer.id,
              label: answer.label
            }));

          return {
            question_index: questionIndex + 1,
            question_key: question.key,
            question_title: question.title,
            selected_answer_ids: selectedAnswers.map((answer) => answer.id),
            selected_answer_labels: selectedAnswers.map((answer) => answer.label)
          };
        });
      }

      flattenValueList(values) {
        return values
          .filter((value) => value !== undefined && value !== null && value !== '')
          .map((value) => String(value))
          .join(',');
      }

      normalizedTrackingPayload(payload = {}) {
        const normalized = { ...payload };
        const products = Array.isArray(payload.products) ? payload.products : [];
        if (products.length) {
          normalized.product_count = products.length;
          normalized.product_handles = this.flattenValueList(products.map((product) => product.handle));
          normalized.product_titles = this.flattenValueList(products.map((product) => product.title));
          normalized.product_variant_ids = this.flattenValueList(products.map((product) => product.variant_id));
          normalized.product_available_count = products.filter((product) => product.available).length;
          normalized.product_value = products.reduce((total, product) => total + (Number(product.price) || 0), 0) / 100;
          normalized.product_compare_value =
            products.reduce((total, product) => total + (Number(product.compare_at_price) || 0), 0) / 100;
          delete normalized.products;
        }

        const selections = Array.isArray(payload.selections) ? payload.selections : [];
        if (selections.length) {
          const selectedAnswerIds = selections.flatMap((selection) => selection.selected_answer_ids || []);
          const selectedAnswerLabels = selections.flatMap((selection) => selection.selected_answer_labels || []);
          normalized.question_keys = this.flattenValueList(selections.map((selection) => selection.question_key));
          normalized.question_count = selections.length;
          normalized.answered_question_count = selections.filter(
            (selection) => (selection.selected_answer_ids || []).length > 0
          ).length;
          normalized.selected_answer_ids = this.flattenValueList(selectedAnswerIds);
          normalized.selected_answer_labels = this.flattenValueList(selectedAnswerLabels);
          delete normalized.selections;
        }

        Object.keys(normalized).forEach((key) => {
          if (Array.isArray(normalized[key])) {
            normalized[key] = this.flattenValueList(normalized[key]);
          }
        });

        return normalized;
      }

      trackEvent(eventName, payload = {}) {
        const detail = {
          event: eventName,
          source: 'skincare-quiz',
          page_path: window.location.pathname,
          ...this.normalizedTrackingPayload(payload)
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);

        const shopifyEventName = eventName.replace(/^elanora_/, 'elanora:');
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish(shopifyEventName, detail);
          } else if (window.analytics && typeof window.analytics.publish === 'function') {
            window.analytics.publish(shopifyEventName, detail);
          }
        } catch (error) {
          console.warn('[skincare-quiz]', 'Unable to publish analytics event', error);
        }

        if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, detail);
        }
      }

      trackAbandonment() {
        if (this.abandonTracked || this.completed || !this.started) return;
        this.abandonTracked = true;
        this.trackEvent('elanora_skin_quiz_abandoned', this.currentSelectionPayload());
      }

      getCartSections(cart) {
        if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
        return cart
          .getSectionsToRender()
          .map((section) => section.id || section.section)
          .filter(Boolean);
      }

      renderCart(cart, parsedState, button) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skincare-quiz' });
        }
        if (cart && typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(button);
        }
        if (cart && typeof cart.renderContents === 'function' && parsedState.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(parsedState);
          cart.classList.remove('is-empty');
          cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
          return;
        }
        if (cart && typeof cart.open === 'function') {
          cart.open(button);
          return;
        }
        window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      }

      productHandleUrl(handle) {
        if (!handle) return '';
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        return `${root}products/${encodeURIComponent(handle)}.js`;
      }

      async getProductVariantId(productCard) {
        const existingId = Number(productCard.dataset.sqProductVariantId);
        if (Number.isFinite(existingId) && existingId > 0) return existingId;

        const handle = productCard.dataset.sqProductHandle;
        if (!handle) return null;

        if (!this.productVariantCache) this.productVariantCache = new Map();
        if (this.productVariantCache.has(handle)) return this.productVariantCache.get(handle);

        const response = await fetch(this.productHandleUrl(handle), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return null;

        const product = await response.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants.find((candidate) => candidate.available) || variants[0];
        const variantId = variant && Number(variant.id);
        const resolvedId = Number.isFinite(variantId) && variantId > 0 ? variantId : null;
        this.productVariantCache.set(handle, resolvedId);
        if (resolvedId) {
          productCard.dataset.sqProductVariantId = String(resolvedId);
          productCard.dataset.sqProductAvailable = String(!variant || variant.available !== false);
        }
        return resolvedId;
      }

      async addResultProducts(button) {
        const card = button.closest('.skincare-quiz__result-card');
        const products = card ? Array.from(card.querySelectorAll('[data-sq-product]')) : [];
        this.trackEvent('elanora_skin_quiz_add_to_cart_clicked', {
          products: this.resultProductsPayload(card || this.resultTarget)
        });
        const resolvedProducts = await Promise.all(
          products.map(async (product) => ({
            id: await this.getProductVariantId(product),
            quantity: 1,
            available: product.dataset.sqProductAvailable !== 'false'
          }))
        );
        const items = resolvedProducts
          .filter((item) => Number.isFinite(item.id) && item.id > 0 && item.available)
          .map((item) => ({ id: item.id, quantity: item.quantity }));

        if (!items.length) {
          this.setBulkAddMessage(button, button.dataset.emptyLabel || button.dataset.errorLabel, true);
          return;
        }

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = this.getCartSections(cart);
        const body = { items };
        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }

        const config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } };
        config.headers = config.headers || {};
        config.headers.Accept = 'application/json';
        config.headers['Content-Type'] = 'application/json';
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(body);

        this.setBulkAddMessage(button, '', false);
        this.setBulkAddLoading(button, true);
        try {
          const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
          const response = await fetch(addUrl, config);
          const parsedState = await response.json();
          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || button.dataset.errorLabel);
          }
          this.setBulkAddMessage(button, button.dataset.successLabel, false);
          this.trackEvent('elanora_skin_quiz_add_to_cart_success', {
            products: this.resultProductsPayload(card || this.resultTarget),
            item_count: items.length
          });
          this.renderCart(cart, parsedState, button);
        } catch (error) {
          this.setBulkAddMessage(button, error.message || button.dataset.errorLabel, true);
          this.trackEvent('elanora_skin_quiz_add_to_cart_error', {
            products: this.resultProductsPayload(card || this.resultTarget),
            error: error.message || button.dataset.errorLabel
          });
        } finally {
          this.setBulkAddLoading(button, false);
        }
      }

      reset() {
        this.index = 0;
        this.selections.clear();
        this.completed = false;
        this.started = true;
        this.abandonTracked = false;
        if (this.welcome) this.welcome.hidden = true;
        if (this.flow) this.flow.hidden = false;
        this.resultTarget.replaceChildren();
        this.resultWrap.hidden = true;
        this.quiz.hidden = false;
        this.trackEvent('elanora_skin_quiz_started', {
          question_total: this.questions.length,
          restarted: true
        });
        this.renderQuestion();
        this.quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    const init = () => {
      document.querySelectorAll('[data-sq-root]').forEach((root) => {
        if (!root.dataset.sqReady) {
          root.dataset.sqReady = 'true';
          new SkincareQuiz(root);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
